<template>
    <component :is="component" v-if="component" :infoData="infoData"></component>
</template>

<script>
    import informationUtil from "@/components/information/informationUtil";
    import util from "@/mixins/util";
    import alertMixin from "@/mixins/alertMixin";

    export default {
        name: "ImageComponent",
        mixins: [ informationUtil,alertMixin],
        components: {},
        props: {
            infoType: '',
            infoKey:'',
        },
        data() {
            return {
                getFunc: '',
                detailApiParamSet: {},
                infoData: {},
            }
        },
        beforeRouterEnter() {
        },
        created() {
            this.initConfig()
        },
        mounted() {
            this.getFile()
        },
        beforeDestroy() {
        },
        destroyed() {
        },
        computed: {
            component() {
                if (this.infoType === 'banner') {
                    return () => import(`@/template/information/BannerLayout`)
                }else if (this.infoKey === 'vision') {
                    return () => import(`@/template/information/VisionLayout`)
                } else if (this.infoKey === 'support') {
                    return () => import(`@/template/information/SupportLayout`)
                } else if (this.infoKey === 'introduce') {
                    return () => import(`@/template/information/IntroductionLayout`)
                }else {
                    return null;
                }
            }
        },
        methods: {
            initConfig() {
                let informationConfig = this.returnInformationConfig(this.infoType);
                this.getFunc = informationConfig.getFunc;
                this.detailApiParamSet = informationConfig.detailApiParamSet
            },
            getFile() {
                let params = this.detailApiParamSet;
                params.a_container_type = this.infoKey
                try {
                    this.$api.$file[this.getFunc](params).then(res => res.Data.Result).then(res => {
                        let type = this.returnFileType(res.Info.type)
                        if (type === true) {
                            this.infoData = res.List[0]
                        }
                        else {
                            this.errorAlert(type)
                        }
                    })
                } catch (e) {
                    console.log(e)
                }
            },
            returnFileType(type) {
                switch (type) {
                    case 1:
                        return true
                    default:
                        return '파일을 불러올 수 없습니다.'
                }
            }
        },
        watch: {},
    }
</script>

<style scoped>

</style>